import React from 'react';

import { FormattedMessage, MessageDescriptor } from 'react-intl';

import Heading from '@atlaskit/heading';
import { Stack, Inline, xcss } from '@atlaskit/primitives';

import { LinkCard, LinkCardProps } from './link-card';

interface LinkCardWrapperProps {
	heading: MessageDescriptor;
	links: LinkCardProps[];
}

const linkCardWrapperStyle = xcss({
	borderRadius: 'border.radius.200',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border',
	backgroundColor: 'elevation.surface.overlay',
	paddingBlockStart: 'space.200',
	paddingBlockEnd: 'space.150',
	paddingInline: 'space.150',
});

export const LinkCardWrapper: React.FC<LinkCardWrapperProps> = ({ heading, links }) => {
	return (
		<Stack space="space.200" xcss={linkCardWrapperStyle} grow="fill">
			<Heading size="xsmall">
				<FormattedMessage {...heading} />
			</Heading>

			<Inline space="space.200">
				{links.map((linkData, index) => (
					<LinkCard key={index} {...linkData} />
				))}
			</Inline>
		</Stack>
	);
};
